<template>
  <swiper
    ref="mySwiper"
    @mouseenter.native="mouseEnterFn"
    @mouseleave.native="mouseLeaveFn"
    :options="swiperOption"
    style="height: 100%"
  >
    <swiper-slide v-for="(value, index) in showImgList" :key="index">
      <div class="imgContent clearFix">
        <div :key="ind" v-for="(v, ind) in value" class="imgItem">
          <div class="imgBox hover">
            <a>
              <div class="promotionWrap">
                <!-- <img v-if="v.is_new === 1" class="imgWidth" src="@/assets/img/newIcon.png" />
                <img v-if="v.is_promotion === 1" class="imgWidth" src="@/assets/img/cuIcon.png" />
                <img v-if="v.is_hot === 1" class="imgWidth" src="@/assets/img/hotIcon.png" />
                <img v-if="v.is_dtc === 1" class="imgWidth" src="@/assets/img/dtcIcon.png" />
                <img v-if="v.is_preferred === 1" class="imgWidth" src="@/assets/img/prefIcon.png" /> -->
              </div>
              <div
                class="imgWrap"
                :class="{ fuzzy: v.dtc_enable === 2 }"
                :style="{ backgroundImage: `url(${v.view_image_src})` }"
              ></div>
              <div class="tipsBar">
                <h5 class="name">{{ v.en_name }}</h5>
                <div class="money">{{ v.purchase_price }}</div>
                <p class="tip-p">{{ v.deliver_goods_text }}</p>
              </div>
              <div class="imgInfo" :productId="v.id">
                <div class="imgInfoWrap" :productId="v.id">
                  <p :productId="v.id"><span class="spanTit" :productId="v.id">Product Name:</span>{{ v.en_name }}</p>
                  <p :productId="v.id"><span class="spanTit" :productId="v.id">Price:</span>${{ v.purchase_price }}</p>

                  <p :productId="v.id">
                    <span class="spanTit" :productId="v.id">Size:</span>
                    <span v-for="(valu, inde) in v.sizes" :key="inde" :productId="v.id">
                      {{ valu.en_name }}
                      <span v-if="inde !== v.sizes.length - 1" :productId="v.id">/</span>
                    </span>
                  </p>
                  <p :productId="v.id">
                    <span class="spanTit" :productId="v.id">Color:</span>
                    <span v-for="(valu, inde) in v.colors" :key="inde">
                      {{ valu.en_name }}
                      <span v-if="inde !== v.colors.length - 1" :productId="v.id">/</span>
                    </span>
                  </p>
                  <p :productId="v.id">
                    <span class="spanTit" :productId="v.id">Material:</span>{{ v.product_material }}
                  </p>
                  <p :productId="v.id"><span class="spanTit" :productId="v.id">Weight:</span>{{ v.weight }}g</p>

                  <p :productId="v.id">
                    <span class="spanTit" :productId="v.id">Delivery time:</span>{{ v.deliver_goods_text }}
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination" style="bottom: 10px"></div>
    <!-- 分页 -->
    <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
    <!-- 箭头左 -->
    <!-- <div class="swiper-button-next" slot="button-next"></div> -->
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { getBasicProduct } from '@/api/goodsLibrary'
export default {
  name: 'Slide',
  data() {
    const self = this
    return {
      flag: true,
      showImgList: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: true,
        on: {
          click(e) {
            const id = e.target.getAttribute('productId')
            self.showImgList.forEach(item => {
              if (item && item.length) {
                item.forEach(it => {
                  if (it.id === +id) {
                    self.showImg(it)
                  }
                })
              }
            })
          }
        }
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  methods: {
    showImg(value) {
      if (this.toHome) {
        window.open(`/home/productDesignDetail?id=${value.id}`)
      } else {
        window.open(`/products/${value.id}`)
      }
    },
    getList() {
      getBasicProduct(
        {
          page: 1,
          per_page: 15,
          category_id: this.categoryId
        },
        this.notLogin
      ).then(res => {
        const id = this.$route.query && this.$route.query.id ? +this.$route.query.id : 0
        const showImgList = res.data.data.filter(item => {
          return item.id !== +id
        })
        const newShowImgList = []
        for (let i = 0; i < showImgList.length; i = i + 5) {
          if (i < 10) {
            newShowImgList.push(showImgList.slice(i, i + 5))
          }
        }
        this.showImgList = newShowImgList
        this.$nextTick(() => {
          if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
            const swiper = this.$refs.mySwiper.$swiper
            swiper.slideTo(1)
          }
        })
      })
    },
    mouseEnterFn() {
      this.$refs.mySwiper.$swiper.autoplay.stop()
    },
    mouseLeaveFn() {
      this.$refs.mySwiper.$swiper.autoplay.start()
    }
  },
  props: ['categoryId', 'notLogin', 'toHome'],
  computed: {},
  watch: {
    dateType() {
      this.getList()
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style scoped lang="less">
.fuzzy {
  filter: blur(10px);
}
.imgContent {
  padding-bottom: 36px;
  text-align: center;
  .imgItem {
    float: left;
    padding: 10px;
    width: 20%;
    .imgBox {
      border-radius: 5px;
      border: 1px solid #ddd;
      position: relative;
      .promotionWrap {
        position: absolute;
        left: 10px;
        top: 10px;
        font-size: 18px;
        color: #1890ff;
        z-index: 2;
        .imgWidth {
          margin: 0 2px;
        }
      }
      .imgWrap {
        min-height: 190px;
        width: 100%;
        overflow: hidden;
        position: relative;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        background-color: #fafafa;
        background-blend-mode: multiply;
        img {
          transition: all 0.3s;
        }
        .pushpin {
          position: absolute;
          right: 0;
          top: 0;
          font-size: 18px;
          color: #1890ff;
        }
      }
      .tipsBar {
        min-height: 84px;
        .name {
          overflow: hidden;
          width: 100%;
          padding: 16px 16px 12px 16px;
          margin-bottom: 0;
          font-size: 16px;
          color: #676767;
          line-height: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;
          vertical-align: middle;
          text-align: center;
        }
        .money {
          font-size: 16px;
          font-weight: 700;
          line-height: 1;
          color: #df0001;
          text-align: center;
        }
        .tip-p {
          position: relative;
          padding: 12px 30px 0 30px;
          margin-bottom: 0;
          font-size: 12px;
          line-height: 26px;
          color: #989898;
          text-align: center;
          .MyCheckBox {
            position: absolute;
            top: 12px;
            right: 0;
          }
        }
      }
      .imgInfo {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.2);
        transition: all 0.3s;
        padding-top: 30px;
        border-radius: 0 0 5px 5px;
        // opacity: 0;
        display: none;
        .imgInfoWrap {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          padding: 10px 20px;
          background: #fff;
          border-radius: 0 0 5px 5px;
          text-align: left;
        }
        p {
          margin-top: 6px;
          margin-bottom: 0;
          color: #666;
          font-size: 14px;
          // padding-left: 25px;
          // transition: all 0.3s ease-in-out;
          // transform: translateY(100px);
          // transition-delay: 0.1s;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          .spanTit {
            padding-right: 20px;
            color: #999;
          }
        }
        // p:nth-child(1) {
        //   transition-delay: 0s;

        //   height: 50px;
        //   color: white;
        //   background: rgb(71, 150, 229);
        //   line-height: 50px;
        //   font-size: 20px;
        //   margin-bottom: 15px;
        //   transform: translateY(100px);
        // }
      }
      &:hover {
        box-shadow: 0px 0px 10px rgba(24, 62, 130, 0.5);
        .check,
        .pushpin {
          visibility: visible;
        }
        // .imgWrap > .imgWidth {
        //   transform: scale(1.25);
        // }
        // .imgWrap > .imgHeight {
        //   transform: scale(1.25);
        // }
        .imgInfo {
          display: block;
          // background: rgba(0, 0, 0, 0.3);
          // p {
          //   opacity: 1;
          //   transform: translateY(0px);
          // }
          // p:nth-child(1) {
          //   transform: translateY(0px);
          // }
        }
      }
      // p {
      //   font-size: 18px;
      //   padding: 0 12px;
      //   &:nth-of-type(1) {
      //     padding-top: 16px;
      //   }
      //   &:last-child {
      //     padding-bottom: 8px;
      //   }
      // }
    }
  }
}
</style>
